import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const labelServiceNew = {
    getAllLabelsNew,
    getLabelNew,
    createLabelNew,
    updateLabelNew,
    updateLabelStatusNew,
};

const MODULE = {
    LABEL: 'rnd-new-product-labels',
};

const API_URL = API.BASE_URL + '/v1';

export async function getAllLabelsNew(filter) {
    const requestOptions = {
        params: {
            date_start: filter?.dateStart,
            date_end: filter?.dateEnd,
            page: filter?.pageNumber,
            size: filter?.pageSize,
            name: filter?.name,
            package_size: filter?.packageSize,
            is_active: filter?.isActive,
        }
    }

    if (typeof filter?.productID === 'string') requestOptions.params.product = filter.productID;

    let array = filter.searchArray;
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            requestOptions.params[searchParam] = word;
        }
    });

    return await apiHelper(API_URL).get(`/${MODULE.LABEL}`, requestOptions);
}

export async function createLabelNew(data) {

    const formData = new FormData();
    formData.append(`product_uuid`, data.productID);
    formData.append(`date`, data.date);
    data.images.forEach((item, index) => {
        formData.append(`images[${index}][remark]`, item.remark);
        formData.append(`images[${index}][size]`, item.size);
        formData.append(`images[${index}][packaging_material]`, item.packagingMaterial);
        if (item.images && item.images.length > 0) {
            item.images.forEach((subItem, subIndex) => {
                if (subItem instanceof File) {
                    formData.append(`images[${index}][images][${subIndex}]`, subItem);
                }
            });
        }
    });

    return apiHelper(API_URL).post(`/${MODULE.LABEL}`, formData);
}

export async function updateLabelNew(data) {

    const formData = new FormData();

    formData.append(`product_uuid`, data.productID);
    formData.append(`date`, data.date);

    data.images.forEach((item, index) => {
        formData.append(`images[${index}][uuid]`, item.id);
        formData.append(`images[${index}][remark]`, item.remark);
        formData.append(`images[${index}][size]`, item.size);
        formData.append(`images[${index}][packaging_material]`, item.packagingMaterial);
        if (item.images && item.images.length > 0) {
            item.images.forEach((subItem, subIndex) => {
                if (subItem instanceof File) {
                    formData.append(`images[${index}][images][${subIndex}]`, subItem);
                }
            });
        }
    });

    data.newImages.forEach((item, index) => {
        formData.append(`new_images[${index}][uuid]`, item.id);
        formData.append(`new_images[${index}][remark]`, item.remark);
        formData.append(`new_images[${index}][size]`, item.size);
        formData.append(`new_images[${index}][packaging_material]`, item.packagingMaterial);
        if (item.images && item.images.length > 0) {
            item.images.forEach((subItem, subIndex) => {
                if (subItem instanceof File) {
                    formData.append(`new_images[${index}][images][${subIndex}]`, subItem);
                }
            });
        }
    });

    formData.append(`_method`, 'put');
    return apiHelper(API_URL).post(`/${MODULE.LABEL}/${data.id}`, formData);
}

export async function updateLabelStatusNew(data) {
    const requestOptions = {
        is_active: data.isActive
    };

    return apiHelper(API_URL).patch(`/${MODULE.LABEL}/${data.id}`, requestOptions);
}

export async function getLabelNew(id) {
    return await apiHelper(API_URL).get(`/${MODULE.LABEL}/${id}`);
}